module.exports = __webpack_public_path__ + "static/media/selector.6043744c.svg";